import request from '@/utils/request'
export function fetchListWithMerchantOptionChildren(params) {
  return request({
    url:'/productCategory/productMerchant/listAllMerchant',
    method:'get',
    params:params
  })
}


// WEBPACK FOOTER //
// ./src/api/productMerchantOption.js